/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFlagDollar = createReactComponent("flag-dollar", "IconFlagDollar", [
  [
    "path",
    {
      d: "M13.222 14.882a4.998 4.998 0 0 1 -1.222 -.882a5 5 0 0 0 -7 0v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v5",
      key: "svg-0"
    }
  ],
  ["path", { d: "M5 21v-7", key: "svg-1" }],
  [
    "path",
    {
      d: "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5",
      key: "svg-2"
    }
  ],
  ["path", { d: "M19 21v1m0 -8v1", key: "svg-3" }]
]);

export { IconFlagDollar as default };
//# sourceMappingURL=IconFlagDollar.js.map
